var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#C95111;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 256,
    cy: 256,
    rx: 137.275,
    ry: 137.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.16,
    className: "st0",
    width: 29.68,
    height: 81.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.16,
    y: 430.38,
    className: "st0",
    width: 29.68,
    height: 81.62
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "181.665,97.56 140.855,26.88 115.15,41.72 155.96,112.41 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.784,
    y: 427.522,
    transform: "matrix(-0.5001 -0.866 0.866 -0.5001 162.3364 978.4368)",
    className: "st0",
    width: 81.618,
    height: 29.677
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.88,140.85 97.565,181.66 112.41,155.96 41.72,115.15 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "399.594,356.04 470.285,396.85 485.125,371.15 414.435,330.34 "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 241.16,
    className: "st0",
    width: 81.625,
    height: 29.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.375,
    y: 241.16,
    className: "st0",
    width: 81.625,
    height: 29.68
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "26.88,371.14 41.72,396.85 112.406,356.04 97.565,330.33 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "485.125,140.85 470.285,115.15 399.594,155.96 414.435,181.66 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.566,
    y: 401.543,
    transform: "matrix(-0.866 -0.5 0.5 -0.866 55.7691 899.6527)",
    className: "st0",
    width: 29.682,
    height: 81.624
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "330.335,97.56 356.04,112.41 396.85,41.72 371.15,26.88 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.2d6dadc9a525990769ec1e9943426c5c.svg";
export { ForwardRef as ReactComponent };